var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#F4B346",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5897_21420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2056 28.6344C19.2018 28.5955 19.1896 28.5596 19.1896 28.5207V28.1873C19.1896 28.0286 19.2155 27.8722 19.2674 27.7234C19.2674 27.7234 20.0983 26.6111 20.4912 25.3042C20.0609 24.3962 19.6703 23.2664 19.6703 22.1463C19.6703 21.8862 19.6894 21.6344 19.7161 21.3864C19.1553 20.799 18.3977 20.4663 17.5607 20.4663C15.8327 20.4663 14.4304 21.8762 14.4304 24.0674C14.4304 25.8206 15.8571 27.7234 15.8571 27.7234C15.9075 27.8722 15.9334 28.0286 15.9334 28.1873V28.5207C15.9334 28.9365 15.6908 29.3149 15.3124 29.4881L13.0472 30.4135C12.5208 30.6562 12.1461 31.1398 12.0417 31.709L12.0027 32.2072C11.9829 32.4666 12.0714 32.7222 12.2484 32.9122C12.4246 33.1037 12.6726 33.2112 12.9328 33.2112H16.6353L16.7871 31.2604L16.797 31.2078C16.9824 30.1847 17.6584 29.3149 18.6029 28.88L19.2056 28.6344Z",
    fill: "#FF882F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9586 31.709C36.8548 31.1398 36.4802 30.6561 35.9538 30.4135L33.6871 29.4881C33.3087 29.3149 33.0676 28.9365 33.0676 28.5207V28.1873C33.0676 28.0286 33.0928 27.8722 33.1446 27.7234C33.1446 27.7234 34.5706 25.8206 34.5706 24.0674C34.5706 21.8762 33.169 20.4663 31.4379 20.4663C30.6025 20.4663 29.8449 20.799 29.2826 21.3879C29.3101 21.6352 29.3292 21.8861 29.3292 22.1463C29.3292 23.2655 28.9393 24.3955 28.5098 25.3033C28.9019 26.6103 29.7343 27.7234 29.7343 27.7234C29.7846 27.8722 29.8113 28.0286 29.8113 28.1873V28.5207C29.8113 28.5596 29.7983 28.5954 29.7945 28.6343L30.3561 28.8632C31.3402 29.3134 32.0162 30.1831 32.2039 31.2062L32.2131 31.2596L32.3642 33.2112H36.0682C36.3284 33.2112 36.5763 33.1037 36.7518 32.9122C36.9288 32.7222 37.0173 32.4666 36.9975 32.2072L36.9586 31.709Z",
    fill: "#FF882F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9622 29.8267L27.2202 28.706C26.7625 28.4954 26.4703 28.0376 26.4703 27.5356V27.1313C26.4703 26.9405 26.5008 26.7505 26.5641 26.5697C26.5641 26.5697 28.2884 24.2687 28.2884 22.1462C28.2884 19.4942 26.5924 17.7891 24.4996 17.7891C22.4076 17.7891 20.7108 19.4942 20.7108 22.1462C20.7108 24.2687 22.4366 26.5697 22.4366 26.5697C22.4984 26.7505 22.5305 26.9405 22.5305 27.1313V27.5356C22.5305 28.0376 22.236 28.4954 21.779 28.706L19.037 29.8267C18.3999 30.1189 17.9459 30.7048 17.8208 31.3945L17.6797 33.2111H24.4996H31.3195L31.1799 31.3945C31.0532 30.7049 30.5993 30.1189 29.9622 29.8267Z",
    fill: "#FF882F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5897_21420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(12 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics4);
export default __webpack_public_path__ + "static/media/statistics4.d21677bda537b998571fd1fd00b2ee27.svg";
export { ForwardRef as ReactComponent };